var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout background"},[_c('the-header'),_c('v-main',[_c('router-view')],1),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }